module.exports = __webpack_public_path__ + "static/media/DownloadIconDefault.bce66428.svg";